import { type ProjectFinancialTransactionFilters } from "./project.types.ts"

const projectSliceName = "project"

const initialFinancialTransactionFilters: ProjectFinancialTransactionFilters = {
  page: 1,
  page_size: 20,
  item_type: null,
  q: null,
  project_type: null,
  project_phase: null,
  status: null,
  entry_type: null
}

export { projectSliceName, initialFinancialTransactionFilters }
